import React from 'react';
import WithNavigation from '../../common/WithNavigation';
import fontWeightMap from '../../../constants/fontMap';
import styles from './NavigationBarItem.scss';

function NavigationBarItem({
  navigationBarItem: { redirectionUrl, text },
  uploadedFont,
  fontStyles,
}) {
  const composeStyles = {};

  if (fontStyles) {
    const { size, fontWeight, colour } = fontStyles;
    composeStyles.fontSize = size;
    composeStyles.fontWeight = fontWeightMap[fontWeight];
    composeStyles.color = colour;
  }

  if (uploadedFont) {
    composeStyles.fontFamily = uploadedFont.family;
  }

  return (
    <WithNavigation
      url={redirectionUrl}
      navigationClass={styles.navigationBarItem}
      navigationStyle={composeStyles}
      renderChildren={(content) => (
        <p
          className={styles.navigationBarItem}
          style={composeStyles}
        >
          {content}
        </p>
      )}
    >
      {text}
    </WithNavigation>
  );
}

export default NavigationBarItem;
